/*
 *
 * Home actions
 *
 */

import * as Types from "./constants";
import * as genericTypes from "routes/constants";

export function showWarning(payload) {
	return {
		type: Types.TOAST_WARNING,
		payload: payload,
	};
}
export function showError(payload) {
	return {
		type: Types.TOAST_ERROR,
		payload: payload,
	};
}

// export function showError(payload) {
// 	return {
// 		type: Types.TOAST_ERROR,
// 		payload: payload,
// 	};
// }

export function resetElection() {
	return {
		type: genericTypes.RESET_ELECTION,
	};
}

export function getProvinceList(payload) {
	return {
		type: Types.GET_PROVINCE_LIST_REQUESTED,
		payload: payload,
	};
}

export function getCountyList(payload) {
	return {
		type: Types.GET_COUNTY_LIST_REQUESTED,
		payload: payload,
	};
}

export function getElection(payload) {
	return {
		type: Types.GET_ELECTION_REQUESTED,
		payload: payload,
	};
}

export function getCampList() {
	return {
		type: Types.GET_CAMP_LIST_REQUESTED,
	};
}

export function getManagementList() {
	return {
		type: Types.GET_MANAGEMENT_LIST_REQUESTED,
	};
}

export function manageVoting(payload) {
	return {
		type: Types.MANAGE_VOTING_REQUESTED,
		payload,
	};
}

export function getElectionQuota(payload) {
	return {
		type: Types.GET_ELECTION_QUOTA_REQUESTED,
		payload: payload,
	};
}

export function setCandidateDialogOpen(payload) {
	return {
		type: Types.SET_CANDIDATE_DIALOG_OPEN,
		payload: payload,
	};
}
export function setCancelCandidateDialogOpen(payload) {
	return {
		type: Types.SET_CANCEL_CANDIDATE_DIALOG_OPEN,
		payload: payload,
	};
}
export function setValidateDialogOpen(payload) {
	return {
		type: Types.SET_VALIDATE_DIALOG_OPEN,
		payload: payload,
	};
}
export function setCandidateStatus(payload) {
	return {
		type: Types.SET_CANDIDATE_STATUS_REQUESTED,
		payload: payload,
	};
}

export function setValidateStatus(payload) {
	return {
		type: Types.SET_VALIDATE_STATUS_REQUESTED,
		payload: payload,
	};
}
//voting 

export function setVotingDialogOpen(payload) {
	return {
		type: Types.SET_VOTING_DIALOG_OPEN,
		payload: payload,
	};
}
export function sendConfirmSMS(payload) {
	return {
		type: Types.SEND_CONFIRM_SMS_REQUESTED,
		payload: payload,
	};
}

export function sendVote(payload) {
	return {
		type: Types.SEND_VOTE_REQUESTED,
		payload: payload,
	};
}

//appoint

export function setAppointDialogOpen(payload) {
	return {
		type: Types.SET_APPOINT_DIALOG_OPEN,
		payload: payload,
	};
}

export function sendAppoint(payload) {
	return {
		type: Types.SEND_APPOINT_REQUESTED,
		payload: payload,
	};
}
//managementElection
export function setManageElectionDialog(payload) {
	return {
		type: Types.SET_MANAGEMENT_ELECTION_DIALOG_OPEN,
		payload: payload,
	};
}
